import { useEffect } from 'react'
declare const window: Window &
  typeof globalThis & {
    intercomSettings: any
  }

const Intercom = ({ gclid }: { gclid?: string }) => {
  useEffect(() => {
    window.intercomSettings = {
      app_id: process.env.INTERCOM_APP_ID,
      gclid: gclid || null,
    }
  }, [gclid])
  return <></>
}
export default Intercom
